const PainelPomp = (props) => {

    let { ling, specs, valid, onCritChange2, sh2, onSpecChange2, onSpecBlur2 } = {...props};
    
    function validPainel (lim) {
        let x = valid (lim, specs.lims, props.comp, specs.crit, specs.od, ling);
        let s = {...specs};
        s.lims[lim] = x;
        props.setSpecs(s);
    }

    function serv (specs, serv) {
        specs.res = null;
        if (specs.crit !== "Ranking") {
            specs.crit = "Intervalo";
            if (serv === 'pomp') {
                specs.lims = props.varGlob.refLim['pomp'][0];
            } else {
                specs.lims = props.varGlob.refLim[serv];
            }
        }
        props.setSpecs(specs);
        props.setComp(serv);
    }

    let prompt = "Disponível Jan2016-Fev2021";
    if (ling === 'uk') prompt = "Jan2016-Feb2021 available";


    return ( 
        <div className="painelpomp">
            <label style={{paddingTop: "10px"}}>A: (FNZ SOV) --- B: (SMT AER PVZ ISM HSJ)</label><br></br><br></br>
            <table>
                <tbody>
                    <tr>
                        <td className="bgrd">
                            <span style={{float: 'left', verticalAlign: "top"}}>Usando como critério:</span>
                        </td>
                        <td className="bgrd">
                            <input type="radio" id="rank" name="rankint" value="Ranking"
                            onClick={(e) => props.setSpecs(onCritChange2(e, {...props.specs}, props.varGlob.refLim, 'pomp'))} 
                            defaultChecked={props.specs.crit === 'Ranking'}
                            style={{marginLeft: "120px", verticalAlign: "top"}}></input>
                            Ranking
                        </td>
                    </tr>
                    <tr>
                        <td className="bgrd" style={{verticalAlign: "top"}}>
                            <input type="radio" id="interv" name="rankint" value="Intervalo AB"
                            onClick={(e) => props.setSpecs(onCritChange2(e, {...props.specs}, props.varGlob.refLim, 'pomp'))}
                            defaultChecked={props.specs.crit === 'Intervalo AB'}
                            style={{verticalAlign:"top"}}></input>
                            Intervalo AB
                        </td>
                        <td className="bgrd">
                            <input type="radio" id="intervT" name="rankint" value="Intervalo T"
                            onClick={(e) => props.setSpecs(onCritChange2(e, {...props.specs}, props.varGlob.refLim, 'pomp'))}
                            defaultChecked={props.specs.crit === 'Intervalo T'}
                            style={{marginLeft: "40px", verticalAlign: "top"}}></input>
                            Intervalo de/para Trindade
                        </td>
                    </tr>
                </tbody>
            </table>
            <table>
                <tbody>
                    <tr>
                        <td className="bgrd" style={{paddingBottom: "10px"}}> Limites: </td>
                        <td className="bgrd" style={{paddingBottom: "10px"}}>
                            <input type="text" id="l1" value={props.specs.lims[0]} maxLength="6" size="4" onBlur={() => validPainel(0)} onChange={(e) => props.setSpecs(sh2(0, e.target.value, {...props.specs}))}></input>
                        </td>
                        <td className="bgrd" style={{paddingBottom: "10px"}}>
                            <input type="text" id="l1" value={props.specs.lims[1]} maxLength="6" size="4" onBlur={() => validPainel(1)} onChange={(e) => props.setSpecs(sh2(1, e.target.value, {...props.specs}))}></input>
                        </td>
                        <td className="bgrd" style={{paddingBottom: "10px"}}>
                            <input type="text" id="l1" value={props.specs.lims[2]} maxLength="6" size="3" onBlur={() => validPainel(2)} onChange={(e) => props.setSpecs(sh2(2, e.target.value, {...props.specs}))}></input>
                        </td>
                        <td className="bgrd" style={{paddingBottom: "10px"}}>
                            <input type="text" id="l1" value={props.specs.lims[3]} maxLength="6" size="3" onBlur={() => validPainel(3)} onChange={(e) => props.setSpecs(sh2(3, e.target.value, {...props.specs}))}></input>
                        </td>
                    </tr>
                </tbody>
            </table>
            <table className="serv">
                <tbody>
                    <tr>
                        <td className="bgrd" style={{textAlign: "left"}}>Dias:  </td>
                        <td className="bgrd">
                            <input type="radio" id="todos" name="dias" value="Todos"
                            style={{verticalAlign: "top"}} defaultChecked={props.specs.dias === 'Todos'}
                            onClick={(e) => props.setSpecs(onSpecChange2(e, 'dias', {...props.specs}))}></input> Todos
                            <input type="radio" id="uteis" name="dias" value="Úteis"
                            style={{verticalAlign: "top"}} defaultChecked={props.specs.dias === 'Úteis'}
                            onClick={(e) => props.setSpecs(onSpecChange2(e, 'dias', {...props.specs}))}></input> Úteis</td>
                    </tr>
                    <tr>
                        <td className="bgrd" style={{textAlign: "left"}}>Anos:  </td>
                        <td className="bgrd">
                            <input type="text" id="Anos" value={props.specs.anos} placeholder={prompt} onChange={(e) => props.setSpecs(onSpecChange2(e, 'anos', {...props.specs}))} onBlur={(e) => props.setSpecs(onSpecBlur2(e, 'anos', {...specs}))}></input>
                        </td>
                        <td className="bgrd" style={{paddingLeft: "4px"}}>
                            <button type="button" title="Colorir troços em função do número de etapas"
                            onClick={() => serv (specs, "ode") }>
                            OD Et </button></td>
                        <td className="bgrd">
                            <button type="button" title="Colorir troços em função do número de validações"
                            onClick={() => serv (specs, "val") }>
                            Valid </button></td>
                    </tr>
                    <tr>
                        <td className="bgrd" style={{textAlign: "left"}}>Meses:  </td>
                        <td className="bgrd">
                            <input type="text" id="Meses" value={props.specs.meses} onChange={(e) => props.setSpecs(onSpecChange2(e, 'meses', {...props.specs}))} onBlur={(e) => props.setSpecs(onSpecBlur2(e, 'meses', {...specs}))}></input></td>
                        <td className="bgrd" style={{paddinLeft: "4px"}}>
                            <button type="button" title="Colorir troços em função do número de viagens"
                            onClick={() => serv (specs, "odv") }>
                            OD Vi </button></td>
                        <td className="bgrd">
                            <button style={{padding: "1px 7px"}}
                            type="button" title="Colorir troços em função da oferta (DETALHES)"
                            onClick={() => serv (specs, "tms") }>
                            TMS </button></td>
                    </tr>
                    <tr>
                        <td className="bgrd" style={{textAlign: "left", paddingBottom: "10px"}}>Horas: </td>
                        <td className="bgrd" style={{paddingBottom: "10px"}}>
                            <input type="text" id="Horas" value={props.specs.horas} onChange={(e) => props.setSpecs(onSpecChange2(e, 'horas', {...props.specs}))} onBlur={(e) => props.setSpecs(onSpecBlur2(e, 'horas', {...specs}))}></input></td>
                        <td className="bgrd" style={{paddingBottom: "10px", paddingLeft: "7px"}}>
                            <button style={{padding: "1px 10px"}} type="button" title="Colorir estações em função do número de cartões diferentes usados"
                            onClick={() => serv (specs, "cart") }>
                            Cart </button></td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
}

export default PainelPomp;